import React from 'react'
import {Route} from "react-router";
import About from "../../views/about/About";
import Landing from "../../views/Landing";
import BookingApprovalConfirmation from '../../views/booking-approval-confirmation/BookingApprovalConfirmation';
import ExternalLanding from "../../views/ExternalLanding";
import UserBasedLandingRedirect from "../UserBasedLandingRedirect";
import Logout from "../../components/Logout";
import Contact from "../../views/Contact";
import LocationProfile from '../../views/location/profile/LocationProfile';
import Login from '../../views/login/Login';
import ChangePassword from '../../views/change-password/ChangePassword';
import ForgotPassword from '../../views/forgot-password/ForgotPassword';
import BlogDetails from '../../views/blog-details/BlogDetails';
import Blog from '../../views/blog/Blog';
import ContextualSignUp from '../../views/signup/ContextualSignUp';
import {AccountType} from '../../components/constants/securspace-constants';
import PolicyDocument from '../../views/policyDocument/PolicyDocument';
import HubSpotResourcesBuyer from "../../views/resources/HubSpotResourcesBuyer";
import HubSpotResourcesSupplier from "../../views/resources/HubSpotResourcesSupplier";
import GmsLanding from "../../views/external-landing/GmsLanding";
import {LandingNav} from "../nav/navs";
import EmailVerification from "../../views/signup/EmailVerification";
import Search from "../../views/search/Search";
import SupplierProfile from "../../views/supplier/profile/SupplierProfile";
import {externalLinks} from "../../requests/external-endpoints";
import {legacyRedirectRoutes} from "../LegacyRedirects";

const LandingContent = (): React.ReactElement<any>[] => {

  return [
    <Route path="/gms-landing" key="/gms-landing" element={<GmsLanding/>}>

    </Route>,
    <Route path="/search" key="/search" element={<Search/>}>

    </Route>,
    <Route path="/supplier/:shortId/:slug?" key="/supplier/:shortId" element={<SupplierProfile/>}>

    </Route>,
    <Route path="/location-profile/:locationId" key="/location-profile/:locationId" element={<LocationProfile/>}>

    </Route>,
    <Route path="/buyer-signup" key="/buyer-signup" element={<ContextualSignUp type={AccountType.BUYER}/>}>

    </Route>,
    <Route path="/supplier-signup" key="/supplier-signup" element={<ContextualSignUp type={AccountType.SUPPLIER}/>}>

    </Route>,
    <Route path="/login" key="/login" element={<Login/>}>

    </Route>,
    <Route path="/forgot-password" key="/forgot-password" element={<ForgotPassword/>}>

    </Route>,
    <Route path="/about" key="/about" element={<About/>}>

    </Route>,
    <Route path="/contact" key="/contact" element={
      <Contact />
    } />,
    <Route path="/faq" key="/faq" element={<ExternalLanding
      url={externalLinks.faqs}
    />}>

    </Route>,

    <Route path="/blogs" key="/blogs" element={<Blog/>}>

    </Route>,

    <Route path="/blog/:postId/:title?" key='/blog' element={<BlogDetails/>}>

    </Route>,
    <Route path="/buyer-resources" key="/buyer-resources" element={<HubSpotResourcesBuyer/>}>

    </Route>,
    <Route path="/supplier-resources" key="/supplier-resources" element={<HubSpotResourcesSupplier/>}>

    </Route>,
    <Route path="/change-password" key="/change-password" element={<ChangePassword isNewUser={false}/>}>

    </Route>,
    <Route path="/set-password" key="/set-password" element={<ChangePassword isNewUser={true}/>}>

    </Route>,
    <Route path="/booking-approval" key="/booking-approval" element={<BookingApprovalConfirmation/>}>

    </Route>,
    <Route path="/logout" key="/logout" element={<Logout/>}>

    </Route>,
    <Route path="/terms-of-use/:versionNumber?" key="/terms-of-use" element={<PolicyDocument type="terms"/>}>

    </Route>,
    <Route path="/privacy-policy/:versionNumber?" key="/privacy-policy"
           element={<PolicyDocument type="privacy-policy"/>}>

    </Route>,
    ...legacyRedirectRoutes(),
    <Route path="/" key="/" element={<Landing/>}>

    </Route>,
    <Route path="*" key="*" element={<UserBasedLandingRedirect/>}>

    </Route>,
    <Route path={LandingNav.EMAIL_VERIFICATION.path} key={LandingNav.EMAIL_VERIFICATION.path}
           element={<EmailVerification/>}/>,
  ]
}

export default LandingContent
